<template>
  <div class="page" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed title="我的信息" class="user_service_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar>

    <!-- 职称 -->
    <van-cell center title="头像">
      <template #right-icon>
        <!-- <van-badge content="-"> -->
        <div class="user-img" @click="editName()"><img :src="userInfo.head_photo" alt=""></div>
        <!-- </van-badge> -->
      </template>
    </van-cell>

    <!-- 昵称 -->
    <van-cell center title="昵称" @click="editName()">
      <template #right-icon>
        <p>{{userInfo.user_nickname}}</p>
      </template>
    </van-cell>

    <!-- 性别 -->
    <!-- <van-cell center title="性别">
      <template #right-icon>
        <p>{{userInfo.gender}}</p>
      </template>
      <template #extra>
        <van-icon name="arrow" />
      </template>
    </van-cell> -->

    <van-cell center title="手机号" @click="editPhone()">
      <template #right-icon>
        <p>{{userInfo.phone_no || '绑定手机号'}}</p>
      </template>
      <template #extra>
        <van-icon name="arrow" />
      </template>
    </van-cell>

    <!-- 收货地址 -->
    <!-- <van-cell center title="收货地址" @click="editName()">
      <template #right-icon>
        <p>{{userInfo.adds}}</p>
      </template>
      <template #extra>
        <van-icon name="arrow" />
      </template>
    </van-cell> -->

    <!-- 绑定微信 -->
    <van-cell center title="绑定微信">
      <template #right-icon>
        <p>{{userInfo.open_id}}</p>
      </template>
    </van-cell>

    <van-dialog v-model="isNameShow" title="修改昵称" show-cancel-button confirm-button-color="#ff5000" @confirm="editNickName">
      <van-field v-model="newName" />
    </van-dialog>

    <!-- 底部按钮 -->
    <!-- <div class="foot-btn">
      <van-button round color="#3F7CFF" block type="primary" @click="goOut">退出登录</van-button>
    </div> -->

  </div>
</template>

<script type="text/babel">
import { getToken, setToken, removeToken } from "@/utils/auth";
export default {
  name: "MineService",
  components: {},
  props: {},
  data() {
    return {
      userInfo: {
        user_nickname: "", //昵称
        head_photo: "", //头像
        phone_no: "", //手机号码
        open_id: "", // openId
      },
      balance: {
        cunsume_amt: 0,
        gift_amt: 0,
        total: 0,
        true_amt: 0,
      },

      isNameShow: false,

      userInfo: {
        headImgUrl: require("../../assets/mine/missing-face.png"),
        mobile: "18839135695",
        nickName: "王德法",
        adds: "深圳市高新区",
        wxCode: "WX12345ddsfgf",
      },
      newName: "",
      aa: {},
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    this.$toast.loading();
    this.getInit(); //获取用户信息
  },
  methods: {
    // 初始化数据
    getInit() {
      let _this = this;
      _this.$post("/api/user_info").then((res) => {
        console.log(res.data, "底部table");
        this.$toast.clear();
        if (res.data && res.data.code == 0) {
          this.userInfo = res.data.data.user;
          this.balance = res.data.data.balance;
        }
      });
    },
    // getUser() {
    //   console.log(this.$store.getters.userInfo);
    //   console.log(this.$store.getters.mobile);
    //   let info = this.$store.getters.userInfo;
    //   this.userInfo = {
    //     headImgUrl: info.headImgUrl || require("../../assets/logo_icon.png"),
    //     mobile: info.mobile || Lockr.get("mobile"),
    //     nickName: info.nickName || Lockr.get("nickName"),
    //     regChannel: info.regChannel || Lockr.get("regChannel"),
    //     regTime: info.regTime || Lockr.get("regTime"),
    //     state: info.state || Lockr.get("state"),
    //   };
    // },
    // 打开修改昵称弹窗
    editName() {
      this.$toast("暂不支持修改！");
      // this.isNameShow = !this.isNameShow;
      // this.newName = this.userInfo.nickName;
    },
    // 修改昵称
    editNickName() {
      this.isNameShow = !this.isNameShow;
      this.userInfo.nickName = this.newName;
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 修改手机号
    editPhone() {
      this.$router.push({ name: "new-bind", query: {} });
    },
    goOut() {
      let _this = this;

      this.$dialog
        .confirm({
          title: "提示",
          message: " 是否退出登录? \n 退出后一些功能将无法使用",
          theme: "round-button",
          confirmButtonText: "取消",
          cancelButtonText: "确定",
          confirmButtonColor: "#ff5000",
          cancelButtonColor: "#CCCCCC",
        })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
          sessionStorage.clear(); //清除数据
          Lockr.rm("mobile");
          Lockr.rm("headImgUrl");
          Lockr.rm("nickName");
          removeToken();
          _this.$router.push({
            name: "index",
            query: {},
          });
          window.location.reload();
        });
    },
  },
};
</script>

<style lang="scss">
.user_service_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
  text-align: left;
}
.user-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.foot-btn {
  position: fixed;
  bottom: 20px;
  left: 0;
  height: 40px;
  width: 100%;
  background-color: #fff;
  padding: 0 15px;
}
</style>
